<div *ngIf="resource" class="container-fluid">
  <form #form="ngForm" (ngSubmit)="saveResource(form)">
    <div mat-dialog-title>
      <div *ngIf="resource.resource_ID" i18n>Edit Resource</div>
      <div *ngIf="!resource.resource_ID" i18n>Add Resource</div>
    </div>
    <div mat-dialog-content>
      <div class="mb-3">
        <div *ngIf="resource.resource_ID" i18n>Make the necessary changes on the form below then click Submit</div>
        <div *ngIf="!resource.resource_ID" i18n>To add a new resource, complete the form below then click Submit.</div>
        <div class="float-right warning col-sm-4" i18n>* Required Information</div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4" for="resourceType_ID"><span class="warning">* </span><span i18n>Resource Type</span></label>
        <div class="col-sm-6">
          <select [(ngModel)]="resource.resourceType_ID" name="resourceType_ID" id="resourceTypeId" class="form-control select-bidit" required #resource_type="ngModel">
            <option [ngValue]="undefined" selected="">-</option>
            <option *ngFor="let type of resourceTypes" [(ngValue)]="type.resourceType_ID">{{type.resourceType_Desc}}</option>
          </select>
          <div [hidden]="!form.submitted || resource_type.valid"
               class="alert alert-danger" i18n>Resource Type is required</div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4" for="resource_Name"><span class="warning">* </span><span i18n>Name</span></label>
        <div class="col-sm-6">
          <input id="resource_Name" name="resource_Name" class="form-control" [(ngModel)]="resource.resource_Name"
                 required #resource_Name="ngModel"
                 [class.field-error]="form.submitted &&resource_Name.invalid">
          <div [hidden]="!form.submitted || resource_Name.valid"
               class="alert alert-danger" i18n>Name is invalid</div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4" for="resource_Desc" i18n>Description</label>
        <div class="col-sm-6">
          <textarea id="resource_Desc" name="resource_Desc" class="form-control" [(ngModel)]="resource.resource_Desc"
                    #resource_Desc="ngModel"
                    [class.field-error]="form.submitted && resource_Desc.invalid">
                    </textarea>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4" for="serialNo" i18n>SerialNo</label>
        <input id="serialNo" name="serialNo" class="form-control col-sm-6" [(ngModel)]="resource.resource_SerialNo">
      </div>

      <div class="mt-3">
        <div [hidden]="!form.submitted || form.valid"
             class="alert alert-danger" i18n>
          Validation issues encountered.  Please review your entered information.
        </div>
      </div>
    </div>
    <div mat-dialog-actions>
      <button type="submit" value="submit" name="submit" id="submit" [disabled]="isRequesting" class="btn btn-bidit-submit btn-md mr-3" i18n>Submit</button>
      <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
    </div>
    <app-spinner [isRunning]="isRequesting"></app-spinner>
  </form>
</div>


